export default "__VITE_ASSET__Cy1$S4Yv__"